<template>

<com-item name="players.groups" :has-more="data.total > 5" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Frequent Groups">

	<template v-slot:about>

		<p>Player combinations played with the most.</p>

	</template>

	<template v-slot:stats>

		<app-users :item="item" v-for="(item, index) in data.groups" :max="5" count-text="play" :key="index" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/groups']

		},

		active: function() {

			return this.data.groups.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersGroups'
			})
		
		}

	}

}

</script>

<style scoped>

</style>